export default __webpack_public_path__ + "static/media/ErrorCouldNotDownload.17dd0687.png";